module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Localization")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.$root.permissions['localization create'] && _vm.$root.permissions['localization update']) ? _c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleNewLocalePanel()
      }
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.createOrEditLanguageCollapse, 'collapse': _vm.createOrEditLanguageCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.createOrEditLanguageCollapse
    }
  }, [(_vm.allLocales.length) ? _c('div', [_c('button', {
    staticClass: "btn create-or-edit",
    class: {
      'blue-chambray': _vm.createOrSelectMode === 'Create a new language', 'blue btn-outline': _vm.createOrSelectMode === 'Edit a language'
    },
    on: {
      "click": _vm.flipCreateAndEditModes
    }
  }, [_vm._v("Create a new language")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'blue-chambray': _vm.createOrSelectMode === 'Edit a language', 'blue btn-outline': _vm.createOrSelectMode === 'Create a new language'
    },
    on: {
      "click": _vm.flipCreateAndEditModes
    }
  }, [_vm._v("Edit a language")])]) : _vm._e(), _vm._v(" "), (_vm.createOrSelectMode === 'Create a new language') ? _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createNewLocale()
      }
    }
  }, [_c('div', {
    staticClass: "form-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createOrEditErrorMessage.length),
      expression: "createOrEditErrorMessage.length"
    }],
    ref: "createOrEditErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError('createOrEditErrorMessage')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.createOrEditErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newLocale.country),
      expression: "newLocale.country"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newLocale.country.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.newLocale.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newLocale, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Language Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newLocale.language_code),
      expression: "newLocale.language_code"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newLocale.language_code.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newLocale.language_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newLocale, "language_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Language Code")])])])]), _vm._v(" "), _vm._m(2, false, false)]) : _vm._e(), _vm._v(" "), (_vm.createOrSelectMode === 'Edit a language') ? _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editLocale()
      }
    }
  }, [_c('div', {
    staticClass: "form-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createOrEditErrorMessage.length),
      expression: "createOrEditErrorMessage.length"
    }],
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError('createOrEditErrorMessage')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.createOrEditErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('el-dropdown', {
    staticClass: "margin-bottom-20",
    attrs: {
      "trigger": "click",
      "size": "small",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.selectLocaleToEdit
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("\n        \t\t\t\t\t" + _vm._s(_vm.selectedLocale.id ? ((_vm.selectedLocale.country) + " (" + (_vm.selectedLocale.language_code) + ")") : 'Select a language')), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.allLocales), function(locale) {
    return _c('el-dropdown-item', {
      key: locale.id,
      attrs: {
        "command": locale
      }
    }, [_vm._v("\n        \t\t\t\t\t\t" + _vm._s(locale.country) + " (" + _vm._s(locale.language_code) + ")\n        \t\t\t\t\t")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localeToBeEdited.country),
      expression: "localeToBeEdited.country"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.localeToBeEdited.country.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.localeToBeEdited.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localeToBeEdited, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Language name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localeToBeEdited.language_code),
      expression: "localeToBeEdited.language_code"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.localeToBeEdited.language_code.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.localeToBeEdited.language_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localeToBeEdited, "language_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Language Code")])])], 1)]), _vm._v(" "), _vm._m(3, false, false)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleNewLocalePanel()
      }
    }
  }, [_vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': _vm.createOrEditLanguageCollapse, 'collapse': !_vm.createOrEditLanguageCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': !_vm.createOrEditLanguageCollapse
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.translationsTableErrorMessage.length),
      expression: "translationsTableErrorMessage.length"
    }],
    ref: "translationsTableErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError('translationsTableErrorMessage')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.translationsTableErrorMessage))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('el-collapse', {
    staticClass: "accordion margin-bottom-20",
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.languageAccordionOpen),
      callback: function($$v) {
        _vm.languageAccordionOpen = $$v
      },
      expression: "languageAccordionOpen"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Language",
      "name": "1"
    }
  }, [_vm._l((_vm.allLocales), function(language) {
    return _c('div', {
      key: language.id,
      staticClass: "clickable",
      class: {
        'active-term': language.language_code === _vm.localeForTranslation.language_code
      },
      on: {
        "click": function($event) {
          _vm.selectLocaleForTranslation(language)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(language.country) + " (" + _vm._s(language.language_code) + ")\n\t\t\t\t\t\t\t")])
  }), _vm._v(" "), (!_vm.allLocales.length) ? _c('div', {
    staticClass: "helper-text"
  }, [_vm._v("No languages yet. Create one above.")]) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localeForTranslation.id),
      expression: "localeForTranslation.id"
    }],
    staticClass: "col-md-6"
  }, [_c('el-collapse', {
    staticClass: "accordion margin-bottom-20",
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeAccordionSection),
      callback: function($$v) {
        _vm.activeAccordionSection = $$v
      },
      expression: "activeAccordionSection"
    }
  }, _vm._l((_vm.translationTermGroups), function(group, index) {
    return _c('el-collapse-item', {
      key: group.group,
      attrs: {
        "title": group.group,
        "name": index + 1
      }
    }, _vm._l((group.terms), function(term) {
      return _c('div', {
        key: term.id,
        staticClass: "clickable",
        class: {
          'active-term': term.term === _vm.activeTranslationGroup.term
        },
        on: {
          "click": function($event) {
            _vm.getTerm(group.groupUrl, term.term)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(term.label) + "\n\t\t\t\t\t\t\t")])
    }))
  }))], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localeForTranslation.id),
      expression: "localeForTranslation.id"
    }],
    staticClass: "translations-table"
  }, [_c('div', {
    staticClass: "translations-table-header"
  }, [_c('div', {
    staticClass: "translations-table-header-cell"
  }, [_vm._v("Term")]), _vm._v(" "), _c('div', {
    staticClass: "translations-table-header-cell"
  }, [_vm._v(_vm._s(_vm.localeForTranslation.country) + " Translation")])]), _vm._v(" "), _vm._l((_vm.terms), function(term, index) {
    return _c('div', {
      key: index,
      staticClass: "translations-table-body",
      attrs: {
        "label": "Field"
      }
    }, [_c('div', {
      staticClass: "translations-table-body-row"
    }, [(_vm.activeTranslationGroup.term.substr(_vm.activeTranslationGroup.term.length - 3) !== 'url') ? _c('div', {
      staticClass: "translations-table-body-cell"
    }, [_vm._v(_vm._s(term.term))]) : _c('div', {
      staticClass: "translations-table-body-cell"
    }, [_c('img', {
      staticClass: "image-thumb clickable",
      attrs: {
        "src": term.term
      },
      on: {
        "click": function($event) {
          _vm.openImagePreview(term.term)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "translations-table-body-cell"
    }, [(_vm.activeTranslationGroup.term.substr(_vm.activeTranslationGroup.term.length - 3) !== 'url') ? _c('div', {
      staticClass: "form-group form-md-line-input form-md-floating-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (term.translation),
        expression: "term.translation"
      }],
      staticClass: "form-control input-sm",
      class: {
        'edited': term.translation.length
      },
      attrs: {
        "type": "text",
        "id": ("term" + (term.id)),
        "disabled": !_vm.$root.permissions['localization update']
      },
      domProps: {
        "value": (term.translation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(term, "translation", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("term" + (term.id))
      }
    }, [_vm._v("Translation")])]) : _c('div', [(!term.translation.length) ? _c('button', {
      staticClass: "btn blue btn-outline",
      attrs: {
        "disabled": !_vm.$root.permissions['localization update']
      },
      on: {
        "click": function($event) {
          _vm.openGallery(term.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tSelect image\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.$root.permissions['localization update'] && _vm.$root.permissions['localization read']) ? _c('img', {
      staticClass: "image-thumb clickable",
      attrs: {
        "src": term.translation
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['localization update']) ? _c('img', {
      staticClass: "image-thumb clickable",
      attrs: {
        "src": term.translation
      },
      on: {
        "click": function($event) {
          _vm.openGallery(term.id)
        }
      }
    }) : _vm._e()])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "left margin-top-20"
  }, [(_vm.terms.length) ? _c('button', {
    staticClass: "btn blue",
    attrs: {
      "disabled": !_vm.$root.permissions['localization update']
    },
    on: {
      "click": function($event) {
        _vm.translateTerms()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingTerms),
      expression: "!loadingTerms"
    }]
  }, [(!_vm.activeTranslationGroup.term) ? _c('p', {
    staticClass: "no-data center"
  }, [_vm._v("Select a term to begin translating.")]) : _vm._e(), _vm._v(" "), (_vm.activeTranslationGroup.term && !_vm.terms.length) ? _c('p', {
    staticClass: "no-data center"
  }, [_vm._v("There are no items to translate.")]) : _vm._e()])], 2)])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.imagePreviewShown,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": function($event) {
        _vm.closeImagePreview()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeImagePreview()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Preview")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('img', {
    staticClass: "image-preview",
    attrs: {
      "src": _vm.imagePreviewUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer clear",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn blue",
    on: {
      "click": function($event) {
        _vm.closeImagePreview()
      }
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.galleryPopupShown,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeGallery
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeGallery
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Select Image To Use in " + _vm._s(_vm.localeForTranslation.country))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('resource-picker', {
    attrs: {
      "noButton": true,
      "showDoneButton": false,
      "imageButton": false,
      "selectOnly": true
    },
    on: {
      "selected": _vm.updateImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer clear",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Create new languages, add and edit translations.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-plus-circle"
  }), _vm._v("\n\t\t\t\t\tCreate or Edit a Language\n\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-actions left margin-top-20"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-actions left margin-top-20"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-plus-circle"
  }), _vm._v("\n\t\t\t\t\tTranslate\n\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21ace1c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Localization/Localization.vue
// module id = 680
// module chunks = 0